import { Component } from '@angular/core';
import { MatIcon } from "@angular/material/icon";
import { globalUser } from '../../helpers/globalFields';
import { DB_User } from '../../interfaces/user';
import { MatCardModule } from "@angular/material/card";
import { MatToolbar, MatToolbarRow } from "@angular/material/toolbar";
import { NgFor } from '@angular/common';
@Component({
  selector: 'app-profile',
  standalone: true,
  imports: [MatIcon, MatCardModule, MatToolbar, MatToolbarRow, NgFor],
  templateUrl: './profile.component.html',
  styleUrl: './profile.component.scss'
})
export class ProfileComponent {

  user : DB_User = globalUser.getUser();
  protected globalUser = globalUser;
  
  constructor() {}
  
  ngOnInit() : void {
  }

}
